import { GridColumnConfig } from "../../../../models/gridCoumnConfig";

export const projectColumns: GridColumnConfig[] = [
  {
    title: 'Customer Name',
    field: 'customerName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Office Name',
    field: 'officeName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Project Name',
    field: 'projectName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Description',
    field: 'projectDescription',
    filter: 'text',
    searchable: true,
    width: '170px',
  },
  {
    title: 'Project Code',
    field: 'projectCode',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Sync With Dux',
    field: 'contactLevelSyncWithDux',
    filter: 'text',
    searchable: true,
  },
];
